<template>
  <div style="font-size: 13px;line-height: 20px">
    <!-- 进度显示 -->
    <div v-if="isProcessing" class="progress-overlay">
      <div class="progress-container">
        <div class="progress-title">{{ status }}</div>
        <div class="progress-bar">
          <div
            class="progress-fill"
            :style="{ width: downloadProgress + '%' }"
          />
        </div>
        <div class="progress-text">
          {{ downloadProgress }}% ({{ currentChunk }}/{{ totalChunks }})
        </div>
      </div>
    </div>
    <div style="text-align: right">
      <el-button size="small" type="primary" @click="generateAndDownloadPDFs()">{{ $t('mdfeTranslate.DownloadAllInvoiceInformation') }}</el-button>
    </div>
    <div
      ref="virtualContainer"
      class="virtual-scroll-container"
      @scroll="handleScroll"
    >
      <div class="virtual-scroll-placeholder" :style="{ height: totalHeight + 'px' }">
        <div
          class="virtual-scroll-content"
          :style="{ transform: `translateY(${offsetY}px)` }"
        >
          <div v-for="(item, index) in visibleItems" :key="index" style="color:#000;padding: 7px">
            <div :id="'pdfData' + index" style="padding: 7px">
              <div style="text-align: center;font-weight: bold;margin-bottom: 20px;">DECLARO QUE RECEBI OS VOLUMES DESTE CONHECIMENTO EM PERFEITO ESTADO PELO QUE DOU POR CUMPRIDO O PRESENTE CONTRATO DE TRANSPORTE</div>
              <div style="display:flex;">
                <div style="width: 35%">
                  <div>NOME</div>
                  <div style="border-bottom: 1px solid black; width: 100%;margin-top: 20px;" />
                  <div>DOCUMENTO</div>
                  <div style="border-bottom: 1px solid black; width: 100%;margin-top: 20px;" />
                </div>
                <div style="width: 200px;padding: 0 10px">
                  <div style="width: 100%;height: 80px;border: 1px solid black;" />
                  <div style="text-align: center">ASSINATURA/CARIMBO</div>
                </div>
                <div style="flex: 1;display:flex;">
                  <div style="flex: 1">
                    <div>TÉRMINO DA PRESTAÇÃO - DATA/HORA</div>
                    <div style="display: flex;padding-right: 10px;">
                      <div style="flex: 1;border-bottom: 1px solid black;" />/
                      <div style="flex: 1;border-bottom: 1px solid black;" />/
                      <div style="flex: 1;border-bottom: 1px solid black;" />
                      <div style="flex: 1;border-bottom: 1px solid black;" />:
                      <div style="flex: 1;border-bottom: 1px solid black;" />
                    </div>
                    <div>INÍCIO DA PRESTAÇÃO - DATA/HORA</div>
                    <div style="display: flex;padding-right: 10px;">
                      <div style="flex: 1;border-bottom: 1px solid black;" />/
                      <div style="flex: 1;border-bottom: 1px solid black;" />/
                      <div style="flex: 1;border-bottom: 1px solid black;" />
                      <div style="flex: 1;border-bottom: 1px solid black;" />:
                      <div style="flex: 1;border-bottom: 1px solid black;" />
                    </div>
                  </div>
                  <div style="width: 200px;">
                    <div style="text-align: right;font-size: 22px">CT-E</div>
                    <div>Nº DOCUMENTO：{{ item.invoiceNumber }}</div>
                    <div>SÉRIE：{{ item.serie }}</div>
                  </div>
                </div>
              </div>
              <div style="padding: 7px 0;border-top: 2px dashed black" />
              <div style="display:flex;">
                <div style="width: 200px;display: flex;flex-direction: column; justify-content: end;">
                  <div style="font-weight: bold">TIPO DO CT-e</div>
                  <div>{{ documentType[item.tpCTe] }}</div>
                </div>
                <div style="width: 300px;">
                  <div style="font-weight: bold">{{ item.company.companyName }} {{ item.company.fantasyName }}</div>
                  <div>{{ item.company.address }}, {{ item.company.number }}</div>
                  <div>{{ item.company.neighborhood }}</div>
                  <div>Telefone: {{ item.company.telephone }}</div>
                  <div>{{ item.company.city }} - {{ item.company.state }} <span style="margin-left: 20px">CEP: {{ item.company.zipcode }}</span></div>
                  <div><span style="font-weight: bold">CNPJ:</span> {{ item.company.companyCnpj }}</div>
                  <div><span style="font-weight: bold">IE:</span> {{ item.company.ie }}</div>
                  <div>
                    <div style="font-weight: bold">TIPO DO SERVIÇO</div>
                    <div>{{ serviceType[item.tpServ] }}</div>
                  </div>
                </div>
                <div style="flex: 1;">
                  <div style="display:flex;">
                    <div style="flex: 1;text-align: center;font-weight: bold">
                      <div>DACTE</div>
                      <div>Documento Auxiliar do</div>
                      <div>Conhecimento de Transporte</div>
                      <div>Eletrônico</div>
                    </div>
                    <div style="flex: 1;display: flex;">
                      <div style="flex: 1">
                        <div style="font-weight: bold">MODAL</div>
                        <div>{{ transportMode[item.modal] }}</div>
                      </div>
                      <div style="flex: 1;text-align: right;padding-right: 10px">
                        <div>FL</div>
                        <div>1/1</div>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex">
                    <div style="width: 80px;">
                      <div style="font-weight: bold;text-align: right">MODEL</div>
                      <div style="text-align: right">{{ item.modelo }}</div>
                    </div>
                    <div style="width: 80px;">
                      <div style="font-weight: bold;text-align: right">SÉRIE</div>
                      <div style="text-align: right">{{ item.serie }}</div>
                    </div>
                    <div style="width: 120px;">
                      <div style="font-weight: bold;text-align: right">NÚMERO</div>
                      <div style="text-align: right">{{ item.invoiceNumber }}</div>
                    </div>
                    <div style="flex: 1;">
                      <div style="font-weight: bold;text-align: center">DATA E HORA DE EMISSÃO</div>
                      <div style="text-align: center">{{ item.cteCreateDate }}</div>
                    </div>
                  </div>
                  <img :id="'barcodeCon' + index">
                  <div>
                    <div>Chave de Acesso</div>
                    <div>
                      {{ item.invoiceKey }}
                    </div>
                  </div>
                </div>
                <div style="width: 200px;">
                  <div :id="'qrcode' + index" style="margin-top: 20px;" />
                </div>
              </div>
              <div style="display: flex;color:#000;margin: 10px 0;">
                <div style="width: 200px;">
                  <div style="font-weight: bold">INDICADOR DO CT-E</div>
                  <div style="display:flex;">
                    <div style="flex: 1">
                      <span style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;" />SIM
                    </div>
                    <div style="flex: 1">
                      <div style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;">X</div>NÃO
                    </div>
                  </div>
                </div>
                <div style="width: 260px;">
                  <div style="font-weight: bold">INF. DO CT-E GLOBALIZADO</div>
                  <div style="display:flex;">
                    <div style="flex: 1">
                      <span style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;" />SIM
                    </div>
                    <div style="flex: 1">
                      <div style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;">X</div>NÃO
                    </div>
                  </div>
                </div>
                <div style="flex: 1">
                  Consulta  <span style="font-weight: bold">http://www.cte.fazenda.gov.br</span>
                </div>
                <div style="flex: 1">
                  <div>TIPO DE CONTRATAÇÃO</div>
                  <div style="display:flex;">
                    <div style="flex: 1">
                      <span style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;" />REDESPACHO
                    </div>
                    <div style="flex: 1">
                      <div style="display: inline-block;padding: 0 5px;border: 2px solid #000;margin-right: 10px;width: 25px;height: 25px;" />SUBCONTRATAÇÃO
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: flex;color:#000;margin-bottom: 5px;">
                <div style="flex: 1">
                  <div style="font-weight: bold">
                    CÓDIGO FISCAL DE OPERAÇÕES E PRESTAÇÕES - NATUREZA DA OPERAÇÃO
                  </div>
                  <div>
                    {{ item.cfop }}
                  </div>
                </div>
                <div style="flex: 1">
                  <div style="font-weight: bold">
                    Protocolo de Autorização de Uso
                  </div>
                  <div>
                    {{ item.protocolo }} - {{ item.cteCreateDate }}
                  </div>
                </div>
              </div>
              <div style="display: flex;margin-bottom: 5px;">
                <div style="flex: 1">
                  <div style="font-weight: bold">
                    INÍCIO DA PRESTAÇÃO
                  </div>
                  <div>
                    {{ item.startCity }} - {{ item.startUf }}
                  </div>
                </div>
                <div style="flex: 1">
                  <div style="font-weight: bold">
                    TÉRMINO DA PRESTAÇÃO
                  </div>
                  <div>
                    {{ item.endCity }} - {{ item.endUf }}
                  </div>
                </div>
              </div>
              <div style="display: flex;margin-bottom: 10px;">
                <div style="flex: 1;border: 1px solid #000;padding: 7px;margin-right: 5px;">
                  <div>REMETENTE <span style="margin-left: 15px">{{ item.remetente.name || 'NÃO INFORMADO' }}</span></div>
                  <div>ENDEREÇO <span style="margin-left: 15px">{{ item.remetente.address || 'NÃO INFORMADO' }}, {{ item.remetente.city || 'NÃO INFORMADO' }} {{ item.remetente.number || 'NÃO INFORMADO' }} {{ item.remetente.neighborhood || 'NÃO INFORMADO' }}</span></div>
                  <div style="display: flex">
                    <div style="flex: 1">
                      <div>MUNICÍPIO <span style="margin-left: 15px">{{ item.remetente.city || 'NÃO INFORMADO' }} - {{ item.remetente.state || 'NÃO INFORMADO' }}</span></div>
                      <div>CNPJ / CPF <span style="margin-left: 15px">{{ item.remetente.cnpj || 'NÃO INFORMADO' }}</span></div>
                      <div>PAÍS <span style="margin-left: 15px">{{ item.remetente.country || 'Brasil' }}</span></div>
                    </div>
                    <div style="flex: 1">
                      <div>CEP <span style="margin-left: 15px">{{ item.remetente.zipcode || 'NÃO INFORMADO' }}</span></div>
                      <div>INSCRIÇÃO <span style="margin-left: 15px">{{ item.remetente.ie || 'NÃO INFORMADO' }}</span></div>
                      <div>FONE <span style="margin-left: 15px">{{ item.remetente.telephone || 'NÃO INFORMADO' }}</span></div>
                    </div>
                  </div>
                </div>
                <div style="flex: 1;border: 1px solid #000;padding: 7px;margin-left: 5px">
                  <div>DESTINATÁRIO <span style="margin-left: 15px">{{ item.destinatario.name || 'NÃO INFORMADO' }}</span></div>
                  <div>ENDEREÇO <span style="margin-left: 15px">{{ item.destinatario.address || 'NÃO INFORMADO' }}, {{ item.destinatario.city || 'NÃO INFORMADO' }} {{ item.destinatario.number || 'NÃO INFORMADO' }} {{ item.destinatario.neighborhood || 'NÃO INFORMADO' }}</span></div>
                  <div style="display: flex">
                    <div style="flex: 1">
                      <div>MUNICÍPIO <span style="margin-left: 15px">{{ item.destinatario.city || 'NÃO INFORMADO' }} - {{ item.destinatario.state || 'NÃO INFORMADO' }}</span></div>
                      <div>CNPJ / CPF <span style="margin-left: 15px">{{ item.destinatario.cnpj || 'NÃO INFORMADO' }}</span></div>
                      <div>PAÍS <span style="margin-left: 15px">{{ item.destinatario.country || 'Brasil' }}</span></div>
                    </div>
                    <div style="flex: 1">
                      <div>CEP <span style="margin-left: 15px">{{ item.destinatario.zipcode || 'NÃO INFORMADO' }}</span></div>
                      <div>INSCRIÇÃO <span style="margin-left: 15px">{{ item.destinatario.ie || 'NÃO INFORMADO' }}</span></div>
                      <div>FONE <span style="margin-left: 15px">{{ item.destinatario.telephone || 'NÃO INFORMADO' }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: flex;margin-bottom: 10px;">
                <div style="flex: 1;border: 1px solid #000;padding: 7px;margin-right: 5px;">
                  <div>EXPEDIDOR <span style="margin-left: 15px">{{ item.expedidor.name || 'NÃO INFORMADO' }}</span></div>
                  <div>ENDEREÇO <span style="margin-left: 15px">{{ item.expedidor.address || 'NÃO INFORMADO' }}, {{ item.expedidor.city || 'NÃO INFORMADO' }} {{ item.expedidor.number || 'NÃO INFORMADO' }} {{ item.expedidor.neighborhood || 'NÃO INFORMADO' }}</span></div>
                  <div style="display: flex">
                    <div style="flex: 1">
                      <div>MUNICÍPIO <span style="margin-left: 15px">{{ item.expedidor.city || 'NÃO INFORMADO' }} - {{ item.expedidor.state || 'NÃO INFORMADO' }}</span></div>
                      <div>CNPJ / CPF <span style="margin-left: 15px">{{ item.expedidor.cnpj || 'NÃO INFORMADO' }}</span></div>
                      <div>PAÍS <span style="margin-left: 15px">{{ item.expedidor.country || 'Brasil' }}</span></div>
                    </div>
                    <div style="flex: 1">
                      <div>CEP <span style="margin-left: 15px">{{ item.expedidor.zipcode || 'NÃO INFORMADO' }}</span></div>
                      <div>INSCRIÇÃO <span style="margin-left: 15px">{{ item.expedidor.ie || 'NÃO INFORMADO' }}</span></div>
                      <div>FONE <span style="margin-left: 15px">{{ item.expedidor.telephone || 'NÃO INFORMADO' }}</span></div>
                    </div>
                  </div>
                </div>
                <div style="flex: 1;border: 1px solid #000;padding: 7px;margin-left: 5px">
                  <div v-if="item.customerId === 24005 || item.customerId === 24147">
                    <div>RECEBEDOR <span style="margin-left: 15px">{{ item.toma.name || 'NÃO INFORMADO' }}</span></div>
                    <div>ENDEREÇO <span style="margin-left: 15px">{{ item.toma.address || 'NÃO INFORMADO' }}, {{ item.toma.city || 'NÃO INFORMADO' }} {{ item.toma.number || 'NÃO INFORMADO' }} {{ item.toma.neighborhood || 'NÃO INFORMADO' }}</span></div>
                    <div style="display: flex">
                      <div style="flex: 1">
                        <div>MUNICÍPIO <span style="margin-left: 15px">{{ item.toma.city || 'NÃO INFORMADO' }} - {{ item.toma.state || 'NÃO INFORMADO' }}</span></div>
                        <div>CNPJ / CPF <span style="margin-left: 15px">{{ item.toma.cnpj || 'NÃO INFORMADO' }}</span></div>
                        <div>PAÍS <span style="margin-left: 15px">{{ item.toma.country || 'Brasil' }}</span></div>
                      </div>
                      <div style="flex: 1">
                        <div>CEP <span style="margin-left: 15px">{{ item.toma.zipcode || 'NÃO INFORMADO' }}</span></div>
                        <div>INSCRIÇÃO <span style="margin-left: 15px">{{ item.toma.ie || 'NÃO INFORMADO' }}</span></div>
                        <div>FONE <span style="margin-left: 15px">{{ item.toma.telephone || 'NÃO INFORMADO' }}</span></div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div>RECEBEDOR <span style="margin-left: 15px">{{ item.recebedor.name || 'NÃO INFORMADO' }}</span></div>
                    <div>ENDEREÇO <span style="margin-left: 15px">{{ item.recebedor.address || 'NÃO INFORMADO' }}, {{ item.recebedor.city || 'NÃO INFORMADO' }} {{ item.recebedor.number || 'NÃO INFORMADO' }} {{ item.recebedor.neighborhood || 'NÃO INFORMADO' }}</span></div>
                    <div style="display: flex">
                      <div style="flex: 1">
                        <div>MUNICÍPIO <span style="margin-left: 15px">{{ item.recebedor.city || 'NÃO INFORMADO' }} - {{ item.recebedor.state || 'NÃO INFORMADO' }}</span></div>
                        <div>CNPJ / CPF <span style="margin-left: 15px">{{ item.recebedor.cnpj || 'NÃO INFORMADO' }}</span></div>
                        <div>PAÍS <span style="margin-left: 15px">{{ item.recebedor.country || 'Brasil' }}</span></div>
                      </div>
                      <div style="flex: 1">
                        <div>CEP <span style="margin-left: 15px">{{ item.recebedor.zipcode || 'NÃO INFORMADO' }}</span></div>
                        <div>INSCRIÇÃO <span style="margin-left: 15px">{{ item.recebedor.ie || 'NÃO INFORMADO' }}</span></div>
                        <div>FONE <span style="margin-left: 15px">{{ item.recebedor.telephone || 'NÃO INFORMADO' }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="border: 1px solid #000;padding: 7px;margin-bottom: 10px;">
                <div style="display: flex;">
                  <div style="flex: 1">
                    TOMADOR DO SERVIÇO {{ item.toma.name || 'NÃO INFORMADO' }}
                  </div>
                  <div style="flex: 1">
                    MUNICÍPIO {{ item.toma.city || 'NÃO INFORMADO' }} - {{ item.toma.state || 'NÃO INFORMADO' }}
                  </div>
                  <div style="flex: 1">
                    CEP <span style="margin-left: 15px">{{ item.toma.zipcode || 'NÃO INFORMADO' }}</span>
                  </div>
                </div>
                <div>
                  ENDEREÇO <span style="margin-left: 15px">{{ item.toma.address || 'NÃO INFORMADO' }}, {{ item.toma.city || 'NÃO INFORMADO' }} {{ item.toma.number || 'NÃO INFORMADO' }} {{ item.toma.neighborhood || 'NÃO INFORMADO' }}</span>
                  PAÍS<span style="margin-left: 25px">{{ item.toma.country || 'Brasil' }}</span>
                </div>
                <div style="display: flex;">
                  <div style="flex: 1">
                    CNPJ / CPF <span style="margin-left: 15px">{{ item.toma.cnpj || 'NÃO INFORMADO' }}</span>
                  </div>
                  <div style="flex: 1">
                    INSCRIÇÃO <span style="margin-left: 15px">{{ item.toma.ie || 'NÃO INFORMADO' }}</span>
                  </div>
                  <div style="flex: 1">
                    FONE <span style="margin-left: 15px">{{ item.toma.telephone || 'NÃO INFORMADO' }}</span>
                  </div>
                </div>
              </div>
              <div style="display: flex;">
                <div style="flex: 1;border: 1px solid #000;padding: 7px;">
                  <div>PRODUTO PREDOMINANTE</div>
                  <div>{{ item.product }}</div>
                </div>
                <div style="flex: 1;border: 1px solid #000;padding: 7px;">
                  <div>OUTRAS CARACTERÍSTICAS DA CARGA</div>
                </div>
                <div style="flex: 1;border: 1px solid #000;padding: 7px;">
                  <div style="text-align: right">VALOR TOTAL DA CARGA</div>
                  <div style="text-align: right">R$ {{ formatNumber(item.productAmount) }}</div>
                </div>
              </div>
              <div style="display: flex;border: 1px solid #000;padding: 7px;">
                <div style="flex: 1;">QUANTIDADE：1</div>
                <div style="flex: 1;">PESO BRUTO (KG)：{{ item.peso }}</div>
                <div style="flex: 1;">QUANTIDADE DE PACOTES：01</div>
                <div style="flex: 1;">PESO AFERIDO (KG)：0</div>
                <div style="flex: 1;">CUBAGEM(M3)：0</div>
              </div>
              <div style="border: 1px solid #000;padding: 7px 7px 0 7px;">
                <div style="padding: 7px;text-align: center;border: 1px solid #000;">COMPONENTES DO VALOR DA PRESTAÇÃO DE SERVIÇO</div>
                <div style="display: flex;">
                  <div
                    v-for="(list, ind) in item.prest.freteDetail"
                    :key="ind"
                    style="flex: 1;border-right: 1px solid #000;padding-right: 10px"
                  >
                    <div style="display: flex;">
                      <div style="flex: 1">NOME</div>
                      <div style="flex: 1;text-align: right">VALOR</div>
                    </div>
                    <div style="display: flex;">
                      <div style="flex: 1">{{ list.name }}</div>
                      <div style="flex: 1;text-align: right">{{ formatNumber(list.value) }}</div>
                    </div>
                  </div>
                  <div style="flex: 1;text-align: right;">
                    <div>VALOR TOTAL DO SERVIÇO</div>
                    <div>R$ {{ formatNumber(item.prest.frete) }}</div>
                    <div>VALOR TOTAL A RECEBER</div>
                    <div>R$ {{ formatNumber(item.prest.receivablesFee) }}</div>
                  </div>
                </div>
              </div>
              <div style="border: 1px solid #000;padding: 7px 7px 0 7px;">
                <div style="padding: 7px;text-align: center;border: 1px solid #000;">INFORMAÇÕES RELATIVAS A IMPOSTO</div>
                <div style="display: flex;">
                  <div style="width: 400px;border-right: 1px solid #000;padding-right: 10px">
                    <div>CLASSIFICAÇÃO TRIBUTÁRIA DO SERVIÇO</div>
                    <div>{{ item.icms.cst }}</div>
                  </div>
                  <div style="flex: 1;border-right: 1px solid #000;padding: 0 10px">
                    <div>BASE DE CÁLCULO</div>
                    <div style="text-align: right">R$ {{ formatNumber(item.icms.vbc) }}</div>
                  </div>
                  <div style="flex: 1;border-right: 1px solid #000;padding: 0 10px">
                    <div>ALÍQUOTA DO ICMS</div>
                    <div style="text-align: right">{{ item.icms.picms }} %</div>
                  </div>
                  <div style="flex: 1;border-right: 1px solid #000;padding: 0 10px">
                    <div>VALOR DO ICMS</div>
                    <div style="text-align: right">R$ {{ formatNumber(item.icms.vicms) }}</div>
                  </div>
                  <div style="flex: 1;border-right: 1px solid #000;padding: 0 10px">
                    <div>% RED BC.</div>
                    <div style="text-align: right">% {{ item.icms.predbc }}</div>
                  </div>
                </div>
              </div>
              <div style="border: 1px solid #000;padding: 7px 7px 0 7px;">
                <div style="padding: 7px;text-align: center;border: 1px solid #000;">DOCUMENTOS ORIGINÁRIOS(NOTA FISCAL ELETRÔNICA)</div>
                <div style="display: flex;">
                  <div style="flex: 1;display: flex;border-right: 1px solid #000;">
                    <div style="width: 100px;">
                      <div style="text-align: left">MODELO</div>
                      <div style="text-align: left">{{ item.associationCte.modelo }}</div>
                    </div>
                    <div style="width: 100px;">
                      <div style="text-align: left">SERIE</div>
                      <div style="text-align: left">{{ item.associationCte.serie }}</div>
                    </div>
                    <div style="width: 100px;">
                      <div style="text-align: left">NÚMERO</div>
                      <div style="text-align: left">{{ item.associationCte.number }}</div>
                    </div>
                    <div style="flex: 1">
                      <div style="text-align: left">CHAVE DE ACESSO</div>
                      <div style="text-align: left">{{ item.associationCte.key }}</div>
                    </div>
                  </div>
                  <div style="flex: 1;display: flex;border-right: 1px solid #000;">
                    <div style="width: 100px;padding-left: 10px">
                      <div style="text-align: left">MODELO</div>
                      <div style="text-align: left">{{ item.nfeOriginalFile.modelo }}</div>
                    </div>
                    <div style="width: 100px;">
                      <div style="text-align: left">SERIE</div>
                      <div style="text-align: left">{{ item.nfeOriginalFile.serie }}</div>
                    </div>
                    <div style="width: 100px;">
                      <div style="text-align: left">NÚMERO</div>
                      <div style="text-align: left">{{ item.nfeOriginalFile.number }}</div>
                    </div>
                    <div style="flex: 1">
                      <div style="text-align: left">CHAVE DE ACESSO</div>
                      <div style="text-align: left">{{ item.nfeOriginalFile.key }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="border: 1px solid #000;padding: 7px;">
                <div>INFORMAÇÕES ADICIONAIS</div>
                <div>
                  <div v-for="(list, ind) in item.additionalInfo" :key="ind">{{ list }}</div>
                </div>
              </div>
              <div style="border: 1px solid #000;margin-top: 20px;padding: 7px 7px 0 7px;">
                <div style="border: 1px solid #000;padding: 7px;">INFORMAÇÕES ESPECÍFICAS DO MODAL RODOVIÁRIO</div>
                <div style="display: flex">
                  <div style="flex: 1;border-right: 1px solid #000;">
                    <div>RNTRC DA EMPRESA</div>
                    <div>{{ item.company.rntrc }}</div>
                  </div>
                  <div style="flex: 2;padding-left: 10px">
                    ESTE CONHECIMENTO DE TRANSPORTE ATENDE À LEGISLAÇÃO DE TRANSPORTE RODOVIÁRIO EM VIGOR
                  </div>
                </div>
              </div>
              <div style="margin-top: 20px;display: flex;margin-bottom: 10px;">
                <div style="flex: 1;border: 1px solid #000;padding: 7px">
                  <div style="border: 1px solid #000;padding: 7px;margin-bottom: 100px">
                    USO EXCLUSIVO DO EMISSOR DO CT - E
                  </div>
                </div>
                <div style="flex: 1;border: 1px solid #000;padding: 7px;">
                  <div style="border: 1px solid #000;padding: 7px">RESERVADO AO FISCO</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JsBarcode from 'jsbarcode';
import qrcode from 'qrcode-generator';
import JsPDF from 'jspdf';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { formatNumber } from '@/utils/tools';
// import html2Canvas from 'html2canvas';
import { icmsTaxType, transportMode, documentType, serviceType, mdfecfop } from '../enumeration';
// import { Loading } from 'element-ui';
export default {
  props: {
    cteData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    rowMDFEData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      icmsTaxType,
      transportMode,
      documentType,
      serviceType,
      mdfecfop,
      options: {
        lock: true,
        // '生成图片中，等待下载'
        text: this.$t('organizationManage.GenerateImageWaitDownload'), // 加载动画的文字
        spinner: 'el-icon-loading', // 加载动画的图标
        background: 'rgba(255,255,255,0.8)', // 加载动画的背景
        customClass: 'custom-loading-zIndex'
      },
      itemHeight: 1800, // 每个item的预估高度
      containerHeight: 600, // 容器高度
      visibleItemCount: 10, // 可见的item数量
      visibleStartIndex: 0, // 可见区域的起始索引
      offsetY: 0, // 偏移量
      // 进度跟踪
      downloadProgress: 0,
      totalChunks: 0,
      currentChunk: 0,
      downloadNum: 0,
      isProcessing: false,
      status: this.$t('mdfeTranslate.Preparing'),
      formatNumber
    };
  },
  computed: {
    // 计算总高度
    totalHeight() {
      return this.cteData.length * this.itemHeight;
    },

    // 计算可见的items
    visibleItems() {
      const start = this.visibleStartIndex;
      const end = Math.min(start + this.visibleItemCount, this.cteData.length);
      return this.cteData.slice(start, end);
    }
  },
  mounted() {
    // Loading.service(this.options);
    // 初始化容器高度
    this.updateContainerHeight();
    // 初始化PDF生成
    this.init();
  },
  methods: {
    init() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.cteData.map((item, index) => {
            // 生成条形码
            const element = document.getElementById('barcodeCon' + index);
            if (element && item.invoiceKey) {
              JsBarcode(element, item.invoiceKey, {
                height: 50,
                displayValue: false
              });
            }
            // 生成二维码
            const qr = qrcode(0, 'M');
            qr.addData(item.qrCodePath);
            qr.make();
            const canvas = document.createElement('canvas');
            const size = 120;
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext('2d');
            const cellSize = size / qr.getModuleCount();
            for (let row = 0; row < qr.getModuleCount(); row++) {
              for (let col = 0; col < qr.getModuleCount(); col++) {
                ctx.fillStyle = qr.isDark(row, col) ? '#000' : '#fff';
                ctx.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
              }
            }
            document.getElementById('qrcode' + index).appendChild(canvas);
          });
          // setTimeout(() => {
          //   this.generateAndDownloadPDFs();
          // }, 500);
        }, 1000);
      });
    },
    // 数组分块
    chunkArray(array, chunkSize) {
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }
      return chunks;
    },
    // 下载pdf.zip
    async generateAndDownloadPDFs() {
      // const loadingInstance = Loading.service(this.options);
      this.downloadNum = 0;
      this.isProcessing = true;
      // 使用setTimeout让浏览器有机会渲染加载动画
      await new Promise(resolve => setTimeout(resolve, 100));

      try {
        // 将cteData分段，每段包含2000个元素
        const segmentSize = 2000;
        const segments = this.chunkArray(Array.from(this.cteData), segmentSize);
        this.totalChunks = segments.length;

        // 逐个处理每个段
        for (let s = 0; s < segments.length; s++) {
          const segment = segments[s];
          this.currentChunk = s + 1;
          this.status = `${this.$t('mdfeTranslate.ProcessingBlock')} ${this.currentChunk}/${this.totalChunks} ${this.$t('mdfeTranslate.Blocks')}`; // 处理第***块
          await this.generateAndDownloadSegmentPDFs(segment, s + 1, segments.length);
          // // 更新进度
          // this.downloadProgress = Math.round((this.currentChunk / this.totalChunks) * 100);
        }

        // this.$message.success('所有PDF文件已分段下载完成');
      } catch (error) {
        console.error('Error in generateAndDownloadPDFs:', error);
        // this.$message.error('生成PDF文件失败: ' + error.message);
        this.status = this.$t('mdfeTranslate.PDFGenerationFailed'); // 'PDF生成失败';
      } finally {
        this.$nextTick(() => {
          // loadingInstance.close();
          this.isProcessing = false;
        });
      }
    },
    // 生成并下载一个段的PDF文件
    async generateAndDownloadSegmentPDFs(segment, segmentIndex, totalSegments) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async(resolve) => {
        try {
          const zip = new JSZip();
          const pdfFolder = zip.folder('pdfs');

          // 逐个生成PDF并添加到ZIP中
          for (let i = 0; i < segment.length; i++) {
            this.downloadNum += 1;
            // 更新进度
            this.downloadProgress = Math.round((this.downloadNum / this.cteData.length) * 100);
            try {
              const pdfBlob = await this.generateSinglePDF(segment[i]);
              pdfFolder.file(`${segment[i].invoiceKey}.pdf`, pdfBlob);

              // 每处理一个PDF后稍作停顿，释放内存
              await new Promise(resolve => setTimeout(resolve, 20));
            } catch (error) {
              console.error('Error generating PDF for:', segment[i].invoiceKey, error);
            }
          }

          // 生成ZIP并下载
          const content = await zip.generateAsync({ type: 'blob' });
          saveAs(content, `MDFE_${this.rowMDFEData.mdfeKey}_Part${segmentIndex}of${totalSegments}.zip`);

          resolve();
        } catch (error) {
          console.error('Error in generateAndDownloadSegmentPDFs:', error);
          resolve(); // 即使出错也继续处理下一个段
        }
      });
    },
    // 生成单个PDF
    async generateSinglePDF(item) {
      return new Promise((resolve) => {
        try {
          const doc = new JsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4'
          });
          // 页高
          const pageHeight = doc.internal.pageSize.height;
          // 页宽
          const pageWidth = doc.internal.pageSize.width;
          const xPosition = 5;
          let yPosition = 3;
          // 外围边框
          doc.rect(xPosition, yPosition, pageWidth - 10, pageHeight - 6);
          yPosition += 4;
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          // 标题
          const title1 = 'DECLARO QUE RECEBI OS VOLUMES DESTE CONHECIMENTO EM PERFEITO ESTADO PELO QUE DOU POR';
          const title2 = 'CUMPRIDO O PRESENTE CONTRATO DE TRANSPORTE';
          const title1Width = doc.getTextWidth(title1);
          const title2Width = doc.getTextWidth(title2);
          doc.text(title1, (pageWidth - title1Width) / 2, yPosition);
          yPosition += 4;
          doc.text(title2, (pageWidth - title2Width) / 2, yPosition);
          doc.setFont('helvetica', 'normal');
          yPosition += 5;
          // 姓名
          doc.text('NOME', xPosition + 5, yPosition);
          // 姓名下方横线
          doc.rect(xPosition + 5, yPosition + 8, 80, 0);
          // 文档
          doc.text('DOCUMENTO', xPosition + 5, yPosition + 12);
          // 文档下方横线
          doc.rect(xPosition + 5, yPosition + 20, 80, 0);
          // 中间方框
          doc.rect(91, yPosition, 60, 21);

          doc.text('TÉRMINO DA PRESTAÇÃO - DATA/HORA', 152, yPosition);
          // 姓名下方横线
          doc.rect(152, yPosition + 8, 17, 0);
          doc.text('/', 169, yPosition + 8);
          doc.rect(169, yPosition + 8, 17, 0);
          doc.text('/', 186, yPosition + 8);
          doc.rect(186, yPosition + 8, 17, 0);
          doc.text(':', 203, yPosition + 8);
          doc.rect(203, yPosition + 8, 17, 0);

          doc.text('INÍCIO DA PRESTAÇÃO - DATA/HORA', 152, yPosition + 12);
          doc.rect(152, yPosition + 20, 17, 0);
          doc.text('/', 169, yPosition + 20);
          doc.rect(169, yPosition + 20, 17, 0);
          doc.text('/', 186, yPosition + 20);
          doc.rect(186, yPosition + 20, 17, 0);
          doc.text(':', 203, yPosition + 20);
          doc.rect(203, yPosition + 20, 17, 0);

          doc.setFontSize(16);
          doc.setFont('helvetica', 'bold');
          doc.text('CT-E', 275, yPosition);
          doc.setFontSize(10);
          doc.setFont('helvetica', 'normal');
          doc.text('Nº DOCUMENTO', 230, yPosition + 12);
          doc.text((item.invoiceNumber || ''), 262, yPosition + 12);
          doc.text('SÉRIE', 230, yPosition + 16);
          doc.text((item.serie || ''), 245, yPosition + 16);
          yPosition += 25;
          const ASSINATURA = 'ASSINATURA/CARIMBO';
          const ASSINATURAWidth = doc.getTextWidth(ASSINATURA);
          doc.text(ASSINATURA, ((60 - ASSINATURAWidth) / 2) + 91, yPosition);
          // yPosition += 5;
          doc.setLineDash([2, 1]); // [线段长度, 间隔长度]
          doc.line(xPosition + 5, yPosition + 2, pageWidth - 10, yPosition); // 从左到右绘制横线
          doc.setLineDash([]);
          yPosition += 6;
          doc.setFont('helvetica', 'bold');
          doc.text(doc.splitTextToSize((item.company.companyName || '') + ' ' + (item.company.fantasyName || ''), 80), xPosition + 30, yPosition);
          // doc.text((item.company.fantasyName || ''), xPosition + 30, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text((item.company.address || '') + ', ' + (item.company.number || ''), xPosition + 30, yPosition + 15);
          doc.text((item.company.neighborhood || ''), xPosition + 30, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('Telefone: ', xPosition + 30, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text((item.company.telephone || ''), xPosition + 48, yPosition + 25);
          doc.text((item.company.city || '') + ' - ' + (item.company.state || ''), xPosition + 30, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP: ', xPosition + 30, yPosition + 35);
          doc.setFont('helvetica', 'normal');
          doc.text((item.company.zipcode || ''), xPosition + 40, yPosition + 35);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ: ', xPosition + 30, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.company.companyCnpj || ''), xPosition + 41, yPosition + 40);
          doc.setFont('helvetica', 'bold');
          doc.text('IE: ', xPosition + 30, yPosition + 45);
          doc.setFont('helvetica', 'normal');
          doc.text((item.company.ie || ''), xPosition + 36, yPosition + 45);
          doc.setFont('helvetica', 'bold');
          doc.text('TIPO DO SERVIÇO', xPosition + 30, yPosition + 50);
          doc.setFont('helvetica', 'normal');
          doc.text((item.tpServ ? this.serviceType[item.tpServ] : ''), xPosition + 30, yPosition + 55);

          doc.setFont('helvetica', 'bold');
          doc.text('DACTE', xPosition + 130, yPosition);
          doc.text('Documento Auxiliar do', xPosition + 130, yPosition + 5);
          doc.text('Conhecimento de Transporte', xPosition + 130, yPosition + 10);
          doc.text('Eletrônico', xPosition + 130, yPosition + 15);
          doc.text('MODAL', xPosition + 190, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text((item.modal ? this.transportMode[item.modal] : ''), xPosition + 190, yPosition + 5);

          doc.setFont('helvetica', 'bold');
          doc.text('MODEL', xPosition + 130, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.modelo || ''), xPosition + 130, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('SÉRIE', xPosition + 150, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.serie || ''), xPosition + 150, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('NÚMERO', xPosition + 165, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.invoiceNumber || ''), xPosition + 165, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('DATA E HORA DE EMISSÃO', xPosition + 190, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.cteCreateDate || ''), xPosition + 190, yPosition + 25);

          doc.text('FL', xPosition + 249, yPosition);
          doc.text('1/1', xPosition + 249, yPosition + 5);
          // 创建条形码canvas
          const barcodeCanvas = document.createElement('canvas');
          JsBarcode(barcodeCanvas, item.invoiceKey, {
            height: 40,
            displayValue: false
          });

          // 添加条形码到PDF
          const barcodeData = barcodeCanvas.toDataURL('image/png');
          const barcodeWidth = 100;
          const barcodeHeight = 20;
          doc.addImage(barcodeData, 'PNG', xPosition + 130, yPosition + 27, barcodeWidth, barcodeHeight);

          // 创建二维码canvas
          const qr = qrcode(0, 'M');
          qr.addData(item.qrCodePath);
          qr.make();

          const qrCanvas = document.createElement('canvas');
          const qrSize = 100;
          qrCanvas.width = qrSize;
          qrCanvas.height = qrSize;
          const ctx = qrCanvas.getContext('2d');

          // 绘制二维码
          for (let row = 0; row < qr.getModuleCount(); row++) {
            for (let col = 0; col < qr.getModuleCount(); col++) {
              ctx.fillStyle = qr.isDark(row, col) ? '#000000' : '#ffffff';
              ctx.fillRect(col * (qrSize / qr.getModuleCount()), row * (qrSize / qr.getModuleCount()),
                qrSize / qr.getModuleCount(), qrSize / qr.getModuleCount());
            }
          }

          // 添加二维码到PDF
          const qrData = qrCanvas.toDataURL('image/png');
          const qrWidth = 30;
          const qrHeight = 30;
          doc.addImage(qrData, 'PNG', xPosition + 255, yPosition, qrWidth, qrHeight);

          doc.setFont('helvetica', 'bold');
          doc.text('TIPO DO CT-e', xPosition + 5, yPosition + 60);
          doc.setFont('helvetica', 'normal');
          doc.text((item.tpCTe ? documentType[item.tpCTe] : ''), xPosition + 5, yPosition + 65);
          doc.text('Chave de Acesso', xPosition + 130, yPosition + 50);
          doc.text(item.invoiceKey, xPosition + 130, yPosition + 55);
          doc.text('Consulta', xPosition + 130, yPosition + 60);
          doc.text('http://www.cte.fazenda.gov.br', xPosition + 150, yPosition + 60);

          doc.setFont('helvetica', 'bold');
          yPosition += 70;
          doc.text('INDICADOR DO CT-E', xPosition + 5, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.rect(xPosition + 5, yPosition + 2, 6, 6);
          doc.text('SIM', xPosition + 13, yPosition + 6);
          doc.rect(xPosition + 25, yPosition + 2, 6, 6);
          doc.text('NÃO', xPosition + 32, yPosition + 6);
          doc.text('X', xPosition + 27, yPosition + 6);

          doc.setFont('helvetica', 'bold');
          doc.text('INF. DO CT-E GLOBALIZADO', xPosition + 60, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.rect(xPosition + 60, yPosition + 2, 6, 6);
          doc.text('SIM', xPosition + 68, yPosition + 6);
          doc.rect(xPosition + 80, yPosition + 2, 6, 6);
          doc.text('NÃO', xPosition + 88, yPosition + 6);
          doc.text('X', xPosition + 82, yPosition + 6);

          doc.setFont('helvetica', 'bold');
          doc.text('TIPO DE CONTRATAÇÃO', xPosition + 180, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.rect(xPosition + 180, yPosition + 2, 6, 6);
          doc.text('REDESPACHO', xPosition + 188, yPosition + 6);
          doc.rect(xPosition + 220, yPosition + 2, 6, 6);
          doc.text('SUBCONTRATAÇÃO', xPosition + 228, yPosition + 6);

          yPosition += 15;
          const halfWidth = pageWidth / 2;
          doc.setFont('helvetica', 'bold');
          doc.text('CÓDIGO FISCAL DE OPERAÇÕES E PRESTAÇÕES - NATUREZA DA OPERAÇÃO', xPosition + 5, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text((item.cfop || ''), xPosition + 5, yPosition + 5);
          doc.setFont('helvetica', 'bold');
          doc.text('INÍCIO DA PRESTAÇÃO', xPosition + 5, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          doc.text((item.startCity || '') + ' - ' + (item.startUf || ''), xPosition + 5, yPosition + 15);

          doc.setFont('helvetica', 'bold');
          doc.text('Protocolo de Autorização de Uso', halfWidth + 5, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text((item.protocolo || '') + ' - ' + (item.cteCreateDate || ''), halfWidth + 5, yPosition + 5);
          doc.setFont('helvetica', 'bold');
          doc.text('TÉRMINO DA PRESTAÇÃO', halfWidth + 5, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          doc.text((item.endCity || '') + ' - ' + (item.endUf || ''), halfWidth + 5, yPosition + 15);
          yPosition += 20;
          doc.rect(xPosition + 5, yPosition, halfWidth - 10, 50);
          doc.rect(halfWidth + 5, yPosition, halfWidth - 15, 50);
          yPosition += 6;
          doc.setFont('helvetica', 'bold');
          doc.text('REMETENTE', xPosition + 6, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.remetente.name || 'NÃO INFORMADO'), 100), xPosition + 30, yPosition);
          doc.setFont('helvetica', 'bold');
          doc.text('ENDEREÇO', xPosition + 6, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          const remetenteAddress = (item.remetente.address || 'NÃO INFORMADO') + ', ' + (item.remetente.city || 'NÃO INFORMADO') + ' ' + (item.remetente.number || 'NÃO INFORMADO') + ' ' + (item.remetente.neighborhood || 'NÃO INFORMADO');
          doc.text(doc.splitTextToSize(remetenteAddress, 110), xPosition + 28, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('MUNICÍPIO', xPosition + 6, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.remetente.city || 'NÃO INFORMADO') + ' - ' + (item.remetente.state || 'NÃO INFORMADO'), 60), xPosition + 28, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP', xPosition + 80, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.remetente.zipcode || 'NÃO INFORMADO'), xPosition + 90, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ / CPF', xPosition + 6, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.remetente.cnpj || 'NÃO INFORMADO'), xPosition + 28, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('INSCRIÇÃO', xPosition + 80, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.remetente.ie || 'NÃO INFORMADO'), xPosition + 105, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('PAÍS', xPosition + 6, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.remetente.country || 'Brasil'), xPosition + 20, yPosition + 40);
          doc.setFont('helvetica', 'bold');
          doc.text('FONE', xPosition + 80, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.remetente.telephone || 'NÃO INFORMADO'), xPosition + 95, yPosition + 40);

          doc.setFont('helvetica', 'bold');
          doc.text('DESTINATÁRIO', halfWidth + 6, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.destinatario.name || 'NÃO INFORMADO'), 100), halfWidth + 34, yPosition);
          doc.setFont('helvetica', 'bold');
          doc.text('ENDEREÇO', halfWidth + 6, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          const destinatarioAddress = (item.destinatario.address || 'NÃO INFORMADO') + ', ' + (item.destinatario.city || 'NÃO INFORMADO') + ' ' + (item.destinatario.number || 'NÃO INFORMADO') + ' ' + (item.destinatario.neighborhood || 'NÃO INFORMADO');
          doc.text(doc.splitTextToSize(destinatarioAddress, 110), halfWidth + 28, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('MUNICÍPIO', halfWidth + 6, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.destinatario.city || 'NÃO INFORMADO') + ' - ' + (item.destinatario.state || 'NÃO INFORMADO'), 60), halfWidth + 28, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP', halfWidth + 80, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.destinatario.zipcode || 'NÃO INFORMADO'), halfWidth + 90, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ / CPF', halfWidth + 6, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.destinatario.cnpj || 'NÃO INFORMADO'), halfWidth + 28, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('INSCRIÇÃO', halfWidth + 80, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.destinatario.ie || 'NÃO INFORMADO'), halfWidth + 105, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('PAÍS', halfWidth + 6, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.destinatario.country || 'Brasil'), halfWidth + 20, yPosition + 40);
          doc.setFont('helvetica', 'bold');
          doc.text('FONE', halfWidth + 80, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.destinatario.telephone || 'NÃO INFORMADO'), halfWidth + 95, yPosition + 40);

          // 添加新页面用于表格数据
          doc.addPage();
          yPosition = 3;
          // 外围边框
          doc.rect(xPosition, yPosition, pageWidth - 10, pageHeight - 6);
          yPosition += 3;
          doc.rect(xPosition + 5, yPosition, halfWidth - 10, 50);
          doc.rect(halfWidth + 5, yPosition, halfWidth - 15, 50);
          yPosition += 6;
          doc.setFont('helvetica', 'bold');
          doc.text('EXPEDIDOR', xPosition + 6, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.expedidor.name || 'NÃO INFORMADO'), 100), xPosition + 30, yPosition);
          doc.setFont('helvetica', 'bold');
          doc.text('ENDEREÇO', xPosition + 6, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          const expedidorAddress = (item.expedidor.address || 'NÃO INFORMADO') + ', ' + (item.expedidor.city || 'NÃO INFORMADO') + ' ' + (item.expedidor.number || 'NÃO INFORMADO') + ' ' + (item.expedidor.neighborhood || 'NÃO INFORMADO');
          doc.text(doc.splitTextToSize(expedidorAddress, 110), xPosition + 28, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('MUNICÍPIO', xPosition + 6, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.expedidor.city || 'NÃO INFORMADO') + ' - ' + (item.expedidor.state || 'NÃO INFORMADO'), 60), xPosition + 28, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP', xPosition + 80, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((item.expedidor.zipcode || 'NÃO INFORMADO'), xPosition + 90, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ / CPF', xPosition + 6, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.expedidor.cnpj || 'NÃO INFORMADO'), xPosition + 28, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('INSCRIÇÃO', xPosition + 80, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((item.expedidor.ie || 'NÃO INFORMADO'), xPosition + 105, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('PAÍS', xPosition + 6, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.expedidor.country || 'Brasil'), xPosition + 20, yPosition + 40);
          doc.setFont('helvetica', 'bold');
          doc.text('FONE', xPosition + 80, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((item.expedidor.telephone || 'NÃO INFORMADO'), xPosition + 95, yPosition + 40);

          const toma = item.customerId === 24005 || item.customerId === 24147 ? item.toma : item.recebedor;
          doc.setFont('helvetica', 'bold');
          doc.text('RECEBEDOR', halfWidth + 6, yPosition);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((toma.name || 'NÃO INFORMADO'), 100), halfWidth + 30, yPosition);
          doc.setFont('helvetica', 'bold');
          doc.text('ENDEREÇO', halfWidth + 6, yPosition + 10);
          doc.setFont('helvetica', 'normal');
          const tomaAddress = (toma.address || 'NÃO INFORMADO') + ', ' + (toma.city || 'NÃO INFORMADO') + ' ' + (toma.number || 'NÃO INFORMADO') + ' ' + (toma.neighborhood || 'NÃO INFORMADO');
          doc.text(doc.splitTextToSize(tomaAddress, 110), halfWidth + 28, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('MUNICÍPIO', halfWidth + 6, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((toma.city || 'NÃO INFORMADO') + ' - ' + (toma.state || 'NÃO INFORMADO'), 60), halfWidth + 28, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP', halfWidth + 80, yPosition + 20);
          doc.setFont('helvetica', 'normal');
          doc.text((toma.zipcode || 'NÃO INFORMADO'), halfWidth + 90, yPosition + 20);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ / CPF', halfWidth + 6, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((toma.cnpj || 'NÃO INFORMADO'), halfWidth + 28, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('INSCRIÇÃO', halfWidth + 80, yPosition + 30);
          doc.setFont('helvetica', 'normal');
          doc.text((toma.ie || 'NÃO INFORMADO'), halfWidth + 105, yPosition + 30);
          doc.setFont('helvetica', 'bold');
          doc.text('PAÍS', halfWidth + 6, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((toma.country || 'Brasil'), halfWidth + 20, yPosition + 40);
          doc.setFont('helvetica', 'bold');
          doc.text('FONE', halfWidth + 80, yPosition + 40);
          doc.setFont('helvetica', 'normal');
          doc.text((toma.telephone || 'NÃO INFORMADO'), halfWidth + 95, yPosition + 40);

          yPosition += 45;
          doc.rect(xPosition + 5, yPosition, pageWidth - 20, 20);
          doc.setFont('helvetica', 'bold');
          doc.text('TOMADOR DO SERVIÇO', xPosition + 6, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text(doc.splitTextToSize((item.toma.name || 'NÃO INFORMADO'), 110), xPosition + 50, yPosition + 5);
          doc.setFont('helvetica', 'bold');
          doc.text('MUNICÍPIO', xPosition + 170, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.city || 'NÃO INFORMADO') + ' - ' + (item.toma.state || 'NÃO INFORMADO'), xPosition + 190, yPosition + 5);
          doc.setFont('helvetica', 'bold');
          doc.text('CEP', xPosition + 250, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.zipcode || 'NÃO INFORMADO'), xPosition + 260, yPosition + 5);
          doc.setFont('helvetica', 'bold');
          doc.text('ENDEREÇO', xPosition + 6, yPosition + 14);
          doc.setFont('helvetica', 'normal');
          doc.text(tomaAddress, xPosition + 28, yPosition + 14);
          doc.setFont('helvetica', 'bold');
          doc.text('PAÍS', xPosition + 230, yPosition + 14);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.country || 'Brasil'), xPosition + 240, yPosition + 14);
          doc.setFont('helvetica', 'bold');
          doc.text('CNPJ / CPF', xPosition + 6, yPosition + 19);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.cnpj || 'NÃO INFORMADO'), xPosition + 28, yPosition + 19);
          doc.setFont('helvetica', 'bold');
          doc.text('INSCRIÇÃO', xPosition + 120, yPosition + 19);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.ie || 'NÃO INFORMADO'), xPosition + 140, yPosition + 19);
          doc.setFont('helvetica', 'bold');
          doc.text('FONE', xPosition + 230, yPosition + 19);
          doc.setFont('helvetica', 'normal');
          doc.text((item.toma.telephone || 'NÃO INFORMADO'), xPosition + 243, yPosition + 19);

          yPosition += 21;
          doc.rect(xPosition + 5, yPosition, pageWidth - 20, 30);
          const threeWidth = pageWidth / 3;
          doc.rect(xPosition + 5, yPosition, threeWidth - 6, 16);
          doc.rect(xPosition + threeWidth - 1, yPosition, threeWidth - 6, 16);
          doc.rect(xPosition + threeWidth * 2 - 7, yPosition, threeWidth - 8, 16);
          doc.setFont('helvetica', 'bold');
          doc.text('PRODUTO PREDOMINANTE', xPosition + 6, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text((item.product || ''), xPosition + 6, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('OUTRAS CARACTERÍSTICAS DA CARGA', xPosition + threeWidth, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text('', xPosition + threeWidth, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('VALOR TOTAL DA CARGA', xPosition + threeWidth * 2 - 5, yPosition + 5);
          doc.setFont('helvetica', 'normal');
          doc.text('R$ ' + formatNumber(item.productAmount), xPosition + threeWidth * 2 - 5, yPosition + 10);
          doc.setFont('helvetica', 'bold');
          doc.text('QUANTIDADE: ', xPosition + 6, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text('1', xPosition + 31, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('PESO BRUTO (KG): ', xPosition + 45, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text((item.peso || ''), xPosition + 80, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('QUANTIDADE DE PACOTES: ', xPosition + 102, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text('01', xPosition + 152, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('PESO AFERIDO (KG): ', xPosition + 167, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text('0', xPosition + 205, yPosition + 25);
          doc.setFont('helvetica', 'bold');
          doc.text('CUBAGEM(M3): ', xPosition + 230, yPosition + 25);
          doc.setFont('helvetica', 'normal');
          doc.text('0', xPosition + 260, yPosition + 25);

          yPosition += 32;
          doc.rect(xPosition + 5, yPosition, pageWidth - 20, 30);
          const COMPONENTES = 'COMPONENTES DO VALOR DA PRESTAÇÃO DE SERVIÇO';
          const COMPONENTESWidth = doc.getTextWidth(COMPONENTES);
          doc.setFont('helvetica', 'bold');
          doc.text(COMPONENTES, (pageWidth - COMPONENTESWidth) / 2, yPosition + 5);
          doc.rect(xPosition + 5, yPosition + 8, pageWidth - 20, 0);
          yPosition += 8;
          // const fourWidth = pageWidth / 4;
          doc.setFont('helvetica', 'normal');
          const dataItem = item.prest.freteDetail || [];
          const fourWidth = (pageWidth - 70) / dataItem.length;
          dataItem.map((item, index) => {
            doc.text('NOME', (xPosition + 6) + index * fourWidth, yPosition + 5);
            doc.text('VALOR', (fourWidth - 20) + index * fourWidth, yPosition + 5);
            doc.text((item.name || ''), (xPosition + 6) + index * fourWidth, yPosition + 12);
            doc.text(formatNumber(item.value), (fourWidth - 20) + index * fourWidth, yPosition + 12);
            doc.rect(fourWidth * (index + 1), yPosition, 0, 22);
          });
          const itemWidth = dataItem.length > 0 ? fourWidth * dataItem.length + 2 : 2;
          doc.text('VALOR TOTAL DO SERVIÇO', itemWidth, yPosition + 5);
          doc.text('R$ ' + formatNumber(item.prest.frete), itemWidth, yPosition + 10);
          doc.text('VALOR TOTAL A RECEBER', itemWidth, yPosition + 15);
          doc.text('R$ ' + formatNumber(item.prest.receivablesFee), itemWidth, yPosition + 20);

          yPosition += 22;
          doc.rect(xPosition + 5, yPosition, pageWidth - 20, 23);
          doc.setFont('helvetica', 'bold');
          const IMPOSTO = 'INFORMAÇÕES RELATIVAS A IMPOSTO';
          const IMPOSTOWidth = doc.getTextWidth(IMPOSTO);
          doc.text(IMPOSTO, (pageWidth - IMPOSTOWidth) / 2, yPosition + 5);
          doc.rect(xPosition + 5, yPosition + 8, pageWidth - 20, 0);
          doc.setFont('helvetica', 'normal');
          doc.text('CLASSIFICAÇÃO TRIBUTÁRIA DO SERVIÇO', xPosition + 6, yPosition + 15);
          doc.text((item.icms.cst || ''), xPosition + 6, yPosition + 20);
          doc.rect(xPosition + 85, yPosition + 8, 0, 15);
          doc.text('BASE DE CÁLCULO', xPosition + 90, yPosition + 15);
          doc.text('R$ ' + formatNumber(item.icms.vbc), xPosition + 90, yPosition + 20);
          doc.rect(xPosition + 130, yPosition + 8, 0, 15);
          doc.text('ALÍQUOTA DO ICMS', xPosition + 135, yPosition + 15);
          doc.text((item.icms.picms || 0) + ' %', xPosition + 135, yPosition + 20);
          doc.rect(xPosition + 180, yPosition + 8, 0, 15);
          doc.text('VALOR DO ICMS', xPosition + 185, yPosition + 15);
          doc.text('R$ ' + formatNumber(item.icms.vicms), xPosition + 185, yPosition + 20);
          doc.rect(xPosition + 230, yPosition + 8, 0, 15);
          doc.text('% RED BC.', xPosition + 235, yPosition + 15);
          doc.text('% ' + (item.icms.predbc || 0), xPosition + 235, yPosition + 20);

          yPosition += 23;
          doc.rect(xPosition + 5, yPosition, pageWidth - 20, 33);
          doc.setFont('helvetica', 'bold');
          const DOCUMENTOS = 'DOCUMENTOS ORIGINÁRIOS(NOTA FISCAL ELETRÔNICA)';
          const DOCUMENTOSWidth = doc.getTextWidth(DOCUMENTOS);
          doc.text(DOCUMENTOS, (pageWidth - DOCUMENTOSWidth) / 2, yPosition + 5);
          doc.rect(xPosition + 5, yPosition + 8, pageWidth - 20, 0);
          doc.setFont('helvetica', 'normal');
          doc.text('MODELO', xPosition + 6, yPosition + 11);
          doc.text((item.associationCte.modelo || ''), xPosition + 6, yPosition + 16);
          doc.text('SERIE', xPosition + 30, yPosition + 11);
          doc.text((item.associationCte.serie || ''), xPosition + 30, yPosition + 16);
          doc.text('NÚMERO', xPosition + 60, yPosition + 11);
          doc.text((item.associationCte.number || ''), xPosition + 60, yPosition + 16);
          doc.text('CHAVE DE ACESSO', xPosition + 90, yPosition + 11);
          doc.text(doc.splitTextToSize((item.associationCte.key || ''), 47), xPosition + 90, yPosition + 16);
          doc.rect(pageWidth / 2, yPosition + 8, 0, 17);

          doc.text('MODELO', pageWidth / 2 + 5, yPosition + 11);
          doc.text((item.nfeOriginalFile.modelo || ''), pageWidth / 2 + 5, yPosition + 16);
          doc.text('SERIE', pageWidth / 2 + 30, yPosition + 11);
          doc.text(doc.splitTextToSize((item.nfeOriginalFile.serie || ''), 29), pageWidth / 2 + 30, yPosition + 16);
          doc.text('NÚMERO', pageWidth / 2 + 60, yPosition + 11);
          doc.text(doc.splitTextToSize((item.nfeOriginalFile.number || ''), 29), pageWidth / 2 + 60, yPosition + 16);
          doc.text('CHAVE DE ACESSO', pageWidth / 2 + 90, yPosition + 11);
          doc.text(doc.splitTextToSize((item.nfeOriginalFile.key || ''), 47), pageWidth / 2 + 90, yPosition + 16);
          doc.rect(xPosition + 5, yPosition + 25, pageWidth - 20, 0);
          doc.text('INFORMAÇÕES ADICIONAIS', xPosition + 6, yPosition + 28);

          doc.addPage();
          yPosition = 3;
          doc.rect(xPosition, yPosition, pageWidth - 10, pageHeight - 6);
          const itemAdditionalInfo = item.additionalInfo || [];
          itemAdditionalInfo.map(item => {
            yPosition += 5;
            if (yPosition > pageHeight - 10) {
              doc.addPage();
              yPosition = 13; // 新页面的起始位置，留出边框空间
              // 为新页面添加外围边框
              doc.rect(xPosition, 3, pageWidth - 10, pageHeight - 6);
            }
            doc.text(item, xPosition + 6, yPosition);
          });
          if (yPosition > pageHeight - 10) {
            doc.addPage();
          }
          doc.rect(xPosition + 5, yPosition + 3, pageWidth - 20, 25);
          doc.text('INFORMAÇÕES ESPECÍFICAS DO MODAL RODOVIÁRIO', xPosition + 6, yPosition + 8);
          doc.rect(xPosition + 5, yPosition + 13, pageWidth - 20, 0);
          doc.text('RNTRC DA EMPRESA', xPosition + 6, yPosition + 20);
          doc.text((item.company.rntrc || ''), xPosition + 6, yPosition + 25);
          doc.rect(xPosition + 5, yPosition + 13, 80, 15);
          doc.text('ESTE CONHECIMENTO DE TRANSPORTE ATENDE À LEGISLAÇÃO DE TRANSPORTE RODOVIÁRIO EM VIGOR', xPosition + 90, yPosition + 20);
          yPosition += 30;
          if (yPosition > pageHeight - 10) {
            doc.addPage();
          }
          doc.rect(xPosition + 5, yPosition + 3, pageWidth - 20, 30);
          doc.rect(pageWidth / 2, yPosition + 3, 0, 30);
          doc.text('USO EXCLUSIVO DO EMISSOR DO CT - E', xPosition + 6, yPosition + 8);
          doc.text('RESERVADO AO FISCO', pageWidth / 2 + 5, yPosition + 8);
          doc.rect(xPosition + 5, yPosition + 10, pageWidth - 20, 0);
          // 返回PDF的Blob
          resolve(doc.output('blob'));
        } catch (error) {
          console.error('Error in generateSinglePDF:', error);
          resolve(new Blob()); // 返回空Blob以避免中断整个流程
        }
      });
    },
    // 创建并下载ZIP文件
    async createAndDownloadZip(pdfBlobs, pdfNames) {
      try {
        const zip = new JSZip();
        const pdfFolder = zip.folder('pdfs');

        // 将所有PDF添加到ZIP中
        for (let i = 0; i < pdfBlobs.length; i++) {
          pdfFolder.file(pdfNames[i], pdfBlobs[i]);
        }

        // 生成ZIP并下载
        const content = await zip.generateAsync({ type: 'blob' });
        saveAs(content, 'MDFE_' + this.rowMDFEData.mdfeKey + '.zip');
      } catch (error) {
        console.error('Error creating ZIP file:', error);
        throw error;
      }
    },
    // 更新容器高度
    updateContainerHeight() {
      if (this.$refs.virtualContainer) {
        this.containerHeight = this.$refs.virtualContainer.clientHeight || 600;
        this.visibleItemCount = Math.ceil(this.containerHeight / this.itemHeight) + 2; // 多渲染几个item以确保滚动顺畅
      }
    },

    // 处理滚动事件
    handleScroll(event) {
      const scrollTop = event.target.scrollTop;
      const newStartIndex = Math.floor(scrollTop / this.itemHeight);

      // 只有当起始索引发生变化时才更新
      if (newStartIndex !== this.visibleStartIndex) {
        this.visibleStartIndex = newStartIndex;
        this.offsetY = newStartIndex * this.itemHeight;
      }
    }
  }
};
</script>
<style>
.custom-loading-zIndex {
  z-index: 3000 !important;
}
</style>
<style scoped>
.virtual-scroll-container {
  height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
  margin: 10px 0;
}

.virtual-scroll-placeholder {
  position: relative;
}

.virtual-scroll-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
/* 进度显示样式 */
.progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4001;
}

.progress-container {
  background: white;
  padding: 30px;
  border-radius: 8px;
  min-width: 300px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.progress-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.progress-bar {
  width: 100%;
  height: 20px;
  background-color: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4CAF50, #45a049);
  border-radius: 10px;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 14px;
  color: #666;
}
</style>
